import { render } from "./filter-shortcuts.vue?vue&type=template&id=4ed94493"
import script from "./filter-shortcuts.js?vue&type=script&lang=js"
export * from "./filter-shortcuts.js?vue&type=script&lang=js"

import "./filter-shortcuts.vue?vue&type=style&index=0&id=4ed94493&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__